import React from 'react';
import { compose } from 'ramda';
import { defaultProps, withHandlers } from 'recompose';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import { TOP } from 'app/analytics/constants/positions';
import {
  FAN_PACK_FREE_TRIAL_SKU,
  LENGTH_OF_COUPON_FREE_TRIAL,
} from 'app/constants/freeTrial';
import {
  couponSelected,
  startCouponFlow,
} from 'app/features/couponCampaign/actions';
import {
  parsedCoupon,
  isLoading,
  mappedCouponSku,
} from 'app/features/couponCampaign/selectors';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import Button from 'app/components/Button/Button';
import { productCtaClicked } from 'app/features/landing/actions';
import { ctaLink } from 'app/features/couponCampaign/landing/components/selectors';

const defaults = {
  type: 'one',
  position: TOP,
  isWideOnMobile: true,
  testId: 'coupon-campaign-product-cta',
  sku: FAN_PACK_FREE_TRIAL_SKU,
  lengthOfFreeTrial: LENGTH_OF_COUPON_FREE_TRIAL,
  children: <FormattedMessage id="coupon_landing_heroblock_cta_title" />,
};

const onClick =
  ({ couponSelected, parsedCoupon, productCtaClicked, ...restProps }) =>
  () => {
    couponSelected(parsedCoupon);
    productCtaClicked(restProps);
  };

const state = { parsedCoupon, isLoading, to: ctaLink, sku: mappedCouponSku };

const actions = { couponSelected, productCtaClicked };

const CouponProductCta = compose(
  defaultProps(defaults),
  withDispatchOnMount(startCouponFlow),
  connect(state, actions),
  withHandlers({ onClick }),
)(Button);

export { onClick };

export default CouponProductCta;
